"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Information = function Information(_ref) {
  var _tour$additionalData, _tour$additionalData$, _tour$additionalData2, _tour$additionalData3, _tour$additionalData4, _tour$additionalData5, _tour$additionalData6, _tour$additionalData7, _tour$additionalData8, _tour$additionalData9;

  var tour = _ref.tour,
      user = _ref.user;

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var name = tour.name,
      externalId = tour.externalId,
      id = tour.id,
      createdAt = tour.createdAt,
      projects = tour.projects;
  var formDefinition = {
    railwayUndertaking: (_tour$additionalData = tour.additionalData) === null || _tour$additionalData === void 0 ? void 0 : (_tour$additionalData$ = _tour$additionalData.railInfo) === null || _tour$additionalData$ === void 0 ? void 0 : _tour$additionalData$.railwayUndertaking,
    senderName: (_tour$additionalData2 = tour.additionalData) === null || _tour$additionalData2 === void 0 ? void 0 : (_tour$additionalData3 = _tour$additionalData2.railInfo) === null || _tour$additionalData3 === void 0 ? void 0 : _tour$additionalData3.senderName,
    receiverName: (_tour$additionalData4 = tour.additionalData) === null || _tour$additionalData4 === void 0 ? void 0 : (_tour$additionalData5 = _tour$additionalData4.railInfo) === null || _tour$additionalData5 === void 0 ? void 0 : _tour$additionalData5.receiverName,
    customerName: (_tour$additionalData6 = tour.additionalData) === null || _tour$additionalData6 === void 0 ? void 0 : (_tour$additionalData7 = _tour$additionalData6.railInfo) === null || _tour$additionalData7 === void 0 ? void 0 : _tour$additionalData7.customerName,
    tariff: (_tour$additionalData8 = tour.additionalData) === null || _tour$additionalData8 === void 0 ? void 0 : (_tour$additionalData9 = _tour$additionalData8.railInfo) === null || _tour$additionalData9 === void 0 ? void 0 : _tour$additionalData9.tariff
  };

  var _usePortalSystemExcha = (0, _hooks.usePortalSystemExchangeProjects)(portalId),
      _usePortalSystemExcha2 = _usePortalSystemExcha.data,
      systemExchangeProjects = _usePortalSystemExcha2 === void 0 ? [] : _usePortalSystemExcha2,
      isLoadingSystemExchangeProjects = _usePortalSystemExcha.isLoading;

  if (isLoadingSystemExchangeProjects) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-2"
  }, name ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.name"
  }), ': '), name) : null, externalId ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.externalId"
  }), ': '), externalId) : null, id ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.tourId"
  }), ': '), id) : null, createdAt ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.details.createdAt"
  }), ': '), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: createdAt,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  })) : null, Object.entries(formDefinition).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    if (!value) {
      return null;
    }

    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "font-bold"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.details.".concat(key)
    }), ': '), value);
  }), (projects === null || projects === void 0 ? void 0 : projects.length) > 0 && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.projectForTour"
  }), ":"), /*#__PURE__*/_react["default"].createElement("div", null, projects.map(function (project) {
    var _ref4 = systemExchangeProjects.find(function (iteratedProject) {
      return iteratedProject.id === project.id;
    }) || {},
        projectName = _ref4.projectName;

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: project.id,
      className: "flex mb-1 mr-2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-col"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "underline"
    }, projectName), (project === null || project === void 0 ? void 0 : project.tourProperties) && Object.entries(project.tourProperties).map(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
          key = _ref6[0],
          value = _ref6[1];

      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "font-bold mr-1"
      }, key, ":"), value);
    })));
  }))));
};

Information.propTypes = {
  tour: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    externalId: _propTypes["default"].string,
    id: _propTypes["default"].string,
    createdAt: _propTypes["default"].string,
    additionalData: _propTypes["default"].shape({
      railInfo: _propTypes["default"].shape({
        railwayUndertaking: _propTypes["default"].string,
        senderName: _propTypes["default"].string,
        receiverName: _propTypes["default"].string,
        customerName: _propTypes["default"].string,
        tariff: _propTypes["default"].string
      })
    }),
    projects: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number,
      tourProperties: _propTypes["default"].shape({})
    }))
  }),
  user: _propTypes["default"].shape({
    timezone: _propTypes["default"].string
  }).isRequired
};
Information.defaultProps = {
  tour: {}
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.rail'])(Information);

exports["default"] = _default;